import { render, staticRenderFns } from "./homeSet.vue?vue&type=template&id=2990ff3d&"
import script from "./homeSet.vue?vue&type=script&scoped=true&lang=js&"
export * from "./homeSet.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./homeSet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports